import { useContext, useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAllDistinctLocations } from '../../services/worktypeLocation';
import UserContext from '../../store/User/UserContext';
import { QueryKey } from '../../enums/QueryKey';

export function useLocationsByLoggedInUserRole(params) {
    const prependAllLocationsOption = params?.prependAllLocationsOption || false;
    const loggedInUser = useContext(UserContext);
    const [locationOptions, setLocationOptions] = useState([]);

    // TEF aliases to WFM in HEMTService.applyTEFAlias, so isWFMUser is true for TEF users too.
    const seesAllLocations = Boolean(loggedInUser?.isWFMUser || loggedInUser?.isWTMUser);

    const { data: locationsForAllAccessUsers } = useQuery({
        queryKey: [QueryKey.DistinctLocations],
        queryFn: getAllDistinctLocations,
        enabled: seesAllLocations,
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (loggedInUser) {
            const locations = seesAllLocations
                ? [...(locationsForAllAccessUsers || [])]
                : [loggedInUser.primaryLocation, ...loggedInUser?.additionalLocations];

            if (locations.length && prependAllLocationsOption) {
                locations.unshift({
                    id: -1,
                    code: '',
                    city: 'Alle Standorte',
                });
            }

            setLocationOptions(locations);
        }
    }, [loggedInUser, locationsForAllAccessUsers, prependAllLocationsOption, seesAllLocations]);

    return [locationOptions];
}
